/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Sellers_Offerstitle1Inputs */

const id_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Penawaran ${i?.name}`)
};

const ms_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tawaran ${i?.name}`)
};

const da_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Tilbud`)
};

const de_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Angebote`)
};

const en_us2_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Offers`)
};

const es_es2_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Juegos de ${i?.name}`)
};

const es_mx2_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofertas de ${i?.name}`)
};

const fil_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mga Offer ni ${i?.name}`)
};

const fr_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offres ${i?.name}`)
};

const it_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offerte di ${i?.name}`)
};

const hu_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ajánlatok`)
};

const nl_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aanbiedingen`)
};

const no_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}-tilbud`)
};

const pl_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferty ${i?.name}`)
};

const pt_br2_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jogos de ${i?.name}`)
};

const pt_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ofertas de ${i?.name}`)
};

const ro_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oferte ${i?.name}`)
};

const fi_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Myyjän ${i?.name} tarjoukset`)
};

const sv_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erbjudanden från ${i?.name}`)
};

const vi_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi ${i?.name}`)
};

const tr_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Teklifleri`)
};

const cs_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nabídky ${i?.name}`)
};

const bg_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оферти от ${i?.name}`)
};

const ru_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предложения ${i?.name}`)
};

const uk_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пропозиції ${i?.name}`)
};

const ar_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`عروض ${i?.name}`)
};

const hi_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ऑफ़र`)
};

const th_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ ${i?.name}`)
};

const ja_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} のオファー`)
};

const zh_cn2_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的目录项`)
};

const zh_hant1_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的目錄項目`)
};

const ko_sellers_offerstitle1 = /** @type {(inputs: Sellers_Offerstitle1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 오퍼`)
};

/**
* | output |
* | --- |
* | "{name} Offers" |
*
* @param {Sellers_Offerstitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_offerstitle1 = /** @type {((inputs: Sellers_Offerstitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Offerstitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_offerstitle1(inputs)
	if (locale === "ms") return ms_sellers_offerstitle1(inputs)
	if (locale === "da") return da_sellers_offerstitle1(inputs)
	if (locale === "de") return de_sellers_offerstitle1(inputs)
	if (locale === "en-US") return en_us2_sellers_offerstitle1(inputs)
	if (locale === "es-ES") return es_es2_sellers_offerstitle1(inputs)
	if (locale === "es-MX") return es_mx2_sellers_offerstitle1(inputs)
	if (locale === "fil") return fil_sellers_offerstitle1(inputs)
	if (locale === "fr") return fr_sellers_offerstitle1(inputs)
	if (locale === "it") return it_sellers_offerstitle1(inputs)
	if (locale === "hu") return hu_sellers_offerstitle1(inputs)
	if (locale === "nl") return nl_sellers_offerstitle1(inputs)
	if (locale === "no") return no_sellers_offerstitle1(inputs)
	if (locale === "pl") return pl_sellers_offerstitle1(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_offerstitle1(inputs)
	if (locale === "pt") return pt_sellers_offerstitle1(inputs)
	if (locale === "ro") return ro_sellers_offerstitle1(inputs)
	if (locale === "fi") return fi_sellers_offerstitle1(inputs)
	if (locale === "sv") return sv_sellers_offerstitle1(inputs)
	if (locale === "vi") return vi_sellers_offerstitle1(inputs)
	if (locale === "tr") return tr_sellers_offerstitle1(inputs)
	if (locale === "cs") return cs_sellers_offerstitle1(inputs)
	if (locale === "bg") return bg_sellers_offerstitle1(inputs)
	if (locale === "ru") return ru_sellers_offerstitle1(inputs)
	if (locale === "uk") return uk_sellers_offerstitle1(inputs)
	if (locale === "ar") return ar_sellers_offerstitle1(inputs)
	if (locale === "hi") return hi_sellers_offerstitle1(inputs)
	if (locale === "th") return th_sellers_offerstitle1(inputs)
	if (locale === "ja") return ja_sellers_offerstitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_offerstitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_offerstitle1(inputs)
	return ko_sellers_offerstitle1(inputs)
});
export { sellers_offerstitle1 as "sellers.offersTitle" }